import React from 'react';
import resume from '../data/resume';

const About = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const textStyle = {
    fontSize: '14px',
    margin: '0 0 10px 0',
    lineHeight: '1.5',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ cat about.txt</div>
      <h2 style={headingStyle}>[ ABOUT ]</h2>
      {resume.summaryLines.map((line, index) => (
        <p key={index} style={textStyle}>&gt; {line}</p>
      ))}
    </section>
  );
};

export default About;
